import React from 'react'
import workingTeam from '../../assets/img/team-working.png'

const AboutSection = () => {
  return (
    <section id="about" className="about section">

      <div className="container section-title" data-aos="fade-up">
        <h2>Sobre nosotros</h2>
        <p>
          Somos un equipo de ingenieros en informática con más de dos años de experiencia en el desarrollo de páginas web.
          Como freelance, ofrecemos soluciones personalizadas para crear sitios web atractivos,
          funcionales y optimizados para cumplir con las necesidades específicas de cada cliente.
          Nos especializamos en diseño web, desarrollo front-end y back-end, asegurando que cada proyecto sea único y eficiente,
          adaptado tanto a la visión del cliente como a las últimas tendencias tecnológicas.
        </p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="row gy-4 justify-content-center">
          <div className="col-lg-4">
            <img src={workingTeam} className="img-fluid" alt=""></img>
          </div>
          <div className="col-lg-8 content">
            <h2>Desarrollo full stack.</h2>
            <p className="fst-italic py-3">
              Contamos con la capacidad de abarcar todo el ciclo de desarrollo de software, desde la fase de análisis y diseño hasta la implementación y mantenimiento.
            </p>
            <i className="bi bi-chevron-right"></i>
            <strong>Visi&oacute;n</strong>
            <p>Ser reconocidos como una empresa líder en el mercado,
              proporcionando soluciones de calidad y innovadoras tecnologías para
              satisfacer las necesidades de nuestros clientes.
            </p>
            <i className="bi bi-chevron-right"></i>
            <strong>Misi&oacute;n</strong>
            <p>Ofrecer soluciones de calidad y innovadoras tecnolog&iacute;as que ayuden a
              nuestros clientes a alcanzar sus objetivos empresariales.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection